import { render, staticRenderFns } from "./sangforLogo.vue?vue&type=template&id=4030a38a&scoped=true&"
import script from "./sangforLogo.vue?vue&type=script&lang=js&"
export * from "./sangforLogo.vue?vue&type=script&lang=js&"
import style0 from "./sangforLogo.vue?vue&type=style&index=0&id=4030a38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4030a38a",
  null
  
)

export default component.exports